<template>
  <div id="layout" style="background: rgba(189,223,215,.8)">
    <slot />
  </div>
</template>

<script>
export default {
  name: "empty-layout"
};
</script>
